"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrWeekDaysList = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const fdr_travel_dates_translations_1 = require("./fdr-travel-dates.translations");
const fdr_travel_dates_styles_1 = require("./fdr-travel-dates.styles");
const moveDays = (days, firstDayOfWeek) => {
    const daysToMove = days.slice(0, firstDayOfWeek);
    const daysToLeave = days.slice(firstDayOfWeek);
    return [...daysToLeave, ...daysToMove];
};
function FdrWeekDaysList({ firstDayOfWeek = 0, }) {
    const [, { language }] = (0, next_i18next_1.useTranslation)();
    const weekDays = language === 'fr' ? fdr_travel_dates_translations_1.FR_WEEKDAYS_SHORT : fdr_travel_dates_translations_1.DE_WEEKDAYS_SHORT;
    return (react_1.default.createElement(fdr_travel_dates_styles_1.FdrWeekDaysListWrapper, { className: "week-day-list-wrapper" }, moveDays(weekDays, firstDayOfWeek).map(weekDay => (react_1.default.createElement("li", { className: "weekDay", key: weekDay }, weekDay)))));
}
exports.FdrWeekDaysList = FdrWeekDaysList;
//# sourceMappingURL=fdr-week-days-list.js.map